
<template>
  <div class="section book-background">
    <div class="layout-content">
      <SubTitle :text="data.titleCh" :subText="data.titleEn" />
      <div class="books-wrapper">
        <div class="books-bg" v-for="(item, index) in data.content" :key="index">
          <img class="books-img" :src="item.bookImg" alt="">

          <a :href="item.link" target="_blank">
            <div class="books-content">
              <p class="books-title">{{item.title}}</p>
              <p class="books-text">{{item.text}}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle.vue'
import { mapState } from 'vuex'

import VueTypes from 'vue-types'

export default {
  components: {
    SubTitle,
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>

.book-background {
  background: #F7F8FA;
}

.books-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.books-bg {
  display: flex;
  justify-content: center;
  width: 580px; height: 168px;
  padding: 14px 26px 14px 14px;
  margin-bottom: 70px;

  @include mobile {
    margin-bottom: 30px;
    padding: 0;
  }
}

.books-img {
  width: 120px; height: 171px;
  margin-right: 26px;
  box-shadow: 0px 2px 40px 0px rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.08);

  @include mobile {
    flex-shrink: 0;
    width: 100px; height: 142px;
    margin-right: 20px;
  }
}

.books-content {
  margin-top: 11px;
  cursor: pointer;

  &:hover {

    .books-title {
      color: #376EFD;
    }
  }
}

.books-title {
  margin-bottom: 24px;
  color: #000000;
  font-size: 18px; font-weight: 600;
  line-height: 30px;

  @include mobile {
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 22px;
  }
}

.books-text {
  color: #828A92;
  line-height: 26px;
  font-size: 15px; font-weight: 400;
  @include row(3);

  @include mobile {
    font-size: 13px;
    line-height: 24px;
  }
}
</style>
